import {
  INDIAN_POKER_CARD_VALUES,
  type IndianPokerCard,
  type IndianPokerRngState,
} from "../types";
import { shuffleWithRng } from "./seeded-random";

const CARD_COPIES = [1, 2] as const;

export function createDeck(deckGeneration: number): readonly IndianPokerCard[] {
  return INDIAN_POKER_CARD_VALUES.flatMap((value) =>
    CARD_COPIES.map((copyNumber) => ({
      id: `g${deckGeneration}-v${value}-c${copyNumber}`,
      value,
    })),
  );
}

export function createShuffledDeck(
  deckGeneration: number,
  rngState: IndianPokerRngState,
): {
  readonly deck: readonly IndianPokerCard[];
  readonly rngState: IndianPokerRngState;
} {
  const result = shuffleWithRng(createDeck(deckGeneration), rngState);
  return {
    deck: result.values,
    rngState: result.rngState,
  };
}
